import L from 'leaflet';

const MAP_CONFIG = {
  CENTER:        [20, 0],
  DEFAULT_ZOOM:  3,
  MIN_ZOOM:      2,
  MAX_ZOOM:      18,
  TILE_URL:      'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  TILE_ATTR:     '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
};

export class MapManager {
  constructor() {
    this.map = null;
  }

  /** Initialise the Leaflet map inside #map */
  init() {
    this.map = L.map('map', {
      center:  MAP_CONFIG.CENTER,
      zoom:    MAP_CONFIG.DEFAULT_ZOOM,
      minZoom: MAP_CONFIG.MIN_ZOOM,
      maxZoom: MAP_CONFIG.MAX_ZOOM,
      zoomControl: true
    });

    L.tileLayer(MAP_CONFIG.TILE_URL, {
      attribution: MAP_CONFIG.TILE_ATTR,
      maxZoom: 18
    }).addTo(this.map);

    return this.map;
  }
}
